import { useEffect, useState } from "react";
import toast from "../../../components/DismissibleToast";
import { Button, Input, Select } from "../../../components/ReadonlyAwareInputs";
import sqldatabaseService from "../../../services/sqldatabase/sqldatabase.service";
import { getIdByName, getNamesFromList } from "../util/homeUtil";

const CopyFromProdModal = () => {
  const [selectedGroupName, setSelectedGroupName] = useState("");
  const [selectedDatabase, setSelectedDatabase] = useState("Sandbox");
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [customNameSuffix, setCustomNameSuffix] = useState();
  const [groupList, setGroupList] = useState([]);
  const [isLoadingGroups, setIsLoadingGroups] = useState(true);
  const [isPosting, setIsPosting] = useState(false);

  const databaseList = ["Default", "Test", "Stage", "Sandbox"];

  useEffect(() => {
    const prodGroupsPromise = sqldatabaseService.getProdGroups();
    toast.promise(prodGroupsPromise, {
      loading: "Loading Prod Groups...",
      success: (response) => {
        if (response?.status === 200) {
          setGroupList(response.data);
        }
        setIsLoadingGroups(false);
        return "Groups Loaded";
      },
      error: (err) => {
        console.error("error loading prod groups:", err);
        return "error loading prod groups";
      },
    });
  }, []);

  const generateCopies = () => {
    setIsPosting(true);
    const copyPromise = sqldatabaseService.postCopyProdGroup(
      selectedGroupId,
      customNameSuffix,
      selectedDatabase,
    );

    toast.promise(copyPromise, {
      loading: "Copying Group from Prod to Sandbox...",
      success: (response) => {
        setIsPosting(false);
        if (response?.status === 200) {
          setSelectedGroupName("");
          setSelectedDatabase("Sandbox");
          return "Coppied Group";
        }
        console.error("Error Copying Group:", response);
        throw new Error("Error Copying Group!");
      },
      error: (err) => {
        setIsPosting(false);
        console.error(
          "Error Caught while copying group from prod to sandbox:",
          err,
        );
        return "Error Copying Group!";
      },
    });
  };

  return (
    <div className="flex-space-between">
      <Select
        placeholder={"Select Group From Prod"}
        value={selectedGroupName}
        className="col"
        style={{ width: "35rem" }}
        searchable
        data={getNamesFromList(groupList)}
        dropdownRenderMode={"portal"}
        disabled={isLoadingGroups || isPosting}
        onSelect={(groupName) => {
          setSelectedGroupName(groupName);
          setSelectedGroupId(getIdByName(groupName, groupList));
        }}
      ></Select>
      <div style={{ flex: "1 0 10px" }}></div>
      <Input
        disabled={isLoadingGroups || isPosting}
        title={"(optional) name suffix"}
        value={customNameSuffix}
        onChange={(val) => {
          setCustomNameSuffix(val);
        }}
        style={{ width: "12rem" }}
      ></Input>
      <div style={{ flex: "1 0 10px" }}></div>
      <Select
        placeHolder={"Select Destination Database"}
        value={selectedDatabase}
        data={databaseList}
        dropdownRenderMode={"portal"}
        disabled={isLoadingGroups || isPosting}
        onSelect={(val) => {
          setSelectedDatabase(val);
        }}
      />
      <div style={{ flex: "1 0 10px" }}></div>
      <Button
        className="col-2 m-1"
        style={{ width: "30%" }}
        disabled={!selectedGroupName || isLoadingGroups || isPosting}
        onClick={() => generateCopies()}
      >
        Copy Group To {selectedDatabase.toString()}
      </Button>
    </div>
  );
};

export default CopyFromProdModal;
